import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import moment from 'moment';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {texts, getLocalizedText} from '../../../../constants/TextConst';
import {createNewTemplate} from '../actions/Screen';
import List from '../../../../components/Common/List';
import NewTemplateInput from './NewTemplateInput';
import TemplateReportField from './TemplateReportField';
import styles from '../styles/templateScreen.module.scss';
import {fetchSysLangs} from '../../../../Localization/languages';

@observer
export default class TemplateReport extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            langs: []
        };
    }

    async componentDidMount() {
        const langs = await fetchSysLangs();
        this.setState({langs});
    }

    handleCreateNewTemplate = (title, lang) => {
        createNewTemplate(this.props.screensStore.selectedScreen, title, lang);
    };

    renderItem({item, index}) {
        return item.isNewTemplate ? (
            <TransitionGroup>
                <CSSTransition
                    classNames={'fade'}
                    timeout={{enter: 1000, exit: 500}}
                    transitionAppear={true}
                >
                    <TemplateReportField
                        field={item}
                        index={index}
                        langs={this.state.langs}
                        isEnglishHTML={this.props.isEnglishHTML}
                    />
                </CSSTransition>
            </TransitionGroup>
        ) : (
            <TemplateReportField
                field={item}
                index={index}
                key={index}
                langs={this.state.langs}
                isEnglishHTML={this.props.isEnglishHTML}
            />
        );
    }

    getSortedListByDate = () => {
        const {screen} = this.props;
        const {fields} = screen.collection;

        return fields.slice().sort((a, b) => {
            const aDate = parseInt(moment(a.filetime, 'DD/MM/YYYY HH:mm').format('X'));
            const bDate = parseInt(moment(b.filetime, 'DD/MM/YYYY HH:mm').format('X'));

            //sort defualt template as first,
            if (b.isDefaultTemplate || a.isDefaultTemplate) return -1;

            return bDate - aDate;
        });
    };

    renderList = () => {
        return (
            <div className="list full">
                <List
                    data={this.getSortedListByDate()}
                    keyExtractor={field => field.name}
                    renderItem={itemParams => this.renderItem(itemParams)}
                />
            </div>
        );
    };

    renderFooter = () => (
        <div className={styles.footer}>
            <NewTemplateInput
                designScreen={this.props.screen}
                placeholder={getLocalizedText(texts.newTemplatePlaceholderText)}
                btntext={getLocalizedText(texts.newTemplateBtnText)}
                onNew={this.handleCreateNewTemplate}
                langs={this.state.langs}
                isEnglishHTML={this.props.isEnglishHTML}
            />
        </div>
    );

    render() {
        const {selected} = this.props.screen;
        return (
            <div className={`${styles.templateScreen} screen`}>
                <div className="content-wrapper wide">
                    <div
                        className={
                            `${styles.contentHeightFix} content container` +
                            (selected && selected.hasContainerData ? ' edit-container' : '')
                        }
                    >
                        {this.renderList()}
                    </div>
                </div>
                {this.renderFooter()}
            </div>
        );
    }
}
